// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Select__Label {
  color: var(--smartflip-blue, #666);
  font-size: 0.75em;
}`, "",{"version":3,"sources":["webpack://./libs/features/feat-form-fields/src/lib/select/select.component.scss"],"names":[],"mappings":"AACE;EACE,kCAAA;EACA,iBAAA;AAAJ","sourcesContent":[".Select {\n  &__Label {\n    color: var(--smartflip-blue, #666);\n    font-size: 0.75em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
